// src/pages/FamilyGalleryPage.js
// Updated: 10/19/2025 12:15 AM

import React from 'react';
import Layout from '../components/common/layout/Layout';
import { useFamily } from '../context/FamilyContext';
import PhotoGallery from '../components/common/PhotoGallery'; // Import the common component

const FamilyGalleryPage = () => {
  const { familyData } = useFamily();

  // Define the storage path for the family gallery
  const familyGalleryPath = familyData ? `families/${familyData.id}/gallery` : null;

  return (
    <Layout>
      {/* Use the common PhotoGallery component */}
      <PhotoGallery
        storagePath={familyGalleryPath}
        title={`${familyData?.familyName || 'Family'} Photo Gallery`}
        emptyMessage={`The ${familyData?.familyName || 'Family'} Gallery is empty.\nUpload some shared memories!`}
      />
      {/* You could add more content to this page if needed */}
    </Layout>
  );
};

export default FamilyGalleryPage;